import {
  CartInteraction,
  CustomerDo,
  OrderDo,
  PageName,
  PageType,
  ProductDo,
  UnbdUdo,
} from '@ecm/data/Ecommerce'

export const buildAccountInformation = (productsDo: ProductDo[]): Partial<UnbdUdo> => ({
  pageName: PageName.AccountInformation,
  pageType: PageType.Checkout,
  productDO: productsDo,
})
export const buildAddresses = (
  productsDo: ProductDo[],
  cartInteraction?: CartInteraction
): Partial<UnbdUdo> => ({
  cartInteraction: cartInteraction,
  pageName: PageName.Addresses,
  pageType: PageType.Category,
  productDO: productsDo,
})
export const buildBilling = (
  productsDo: ProductDo[],
  customerDo: CustomerDo,
  order: OrderDo
): Partial<UnbdUdo> => ({
  ...order,
  customerDO: customerDo,
  pageName: PageName.Billing,
  pageType: PageType.Checkout,
  productDO: productsDo,
})
export const buildPricingPlans = (
  productsDo: ProductDo[],
  cartInteraction?: CartInteraction
): Partial<UnbdUdo> => ({
  cartInteraction: cartInteraction,
  pageName: PageName.PricingPlans,
  pageType: PageType.Category,
  productDO: productsDo,
})
export const buildPurchase = (
  productsDo: ProductDo[],
  customerDo: CustomerDo,
  order: OrderDo
): Partial<UnbdUdo> => ({
  ...order,
  customerDO: customerDo,
  pageName: PageName.Purchase,
  pageType: PageType.Purchase,
  productDO: productsDo,
})
export const buildReviewOrder = (
  productsDo: ProductDo[],
  customerDo: CustomerDo,
  order: OrderDo
): Partial<UnbdUdo> => ({
  ...order,
  customerDO: customerDo,
  pageName: PageName.ReviewOrder,
  pageType: PageType.Checkout,
  productDO: productsDo,
})
